import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { format } from "date-fns";
import { useState } from "react";
import Icon from "../../../icons";
import { cn } from "../../../utils";
import Button from "../../Button";
import Calendar from "../../Calendar";
import Divider from "../../Divider";
import Popover, { PopoverContent, PopoverTrigger } from "../../Popover";
import { months } from "../constants";
import { Presets } from "../types";
import DatePresets from "./DatePresets";
import RangeDatePickerHeader from "./RangeDatePickerHeader";
const RangeDatePicker = ({ selected, onSelect, availablePresets, placeholder = "Selecionar período", size = "md", disabled, disabledTrigger, portal, defaultMonth, yearsRange, className, classNameContent, ...calendarProps }) => {
    const [range, setRange] = useState(selected);
    const [startMonth, setStartMonth] = useState(defaultMonth || range?.from || new Date());
    const [endMonth, setEndMonth] = useState(range?.to || new Date());
    const [startYear, setStartYear] = useState(startMonth.getFullYear());
    const [endYear, setEndYear] = useState(endMonth.getFullYear());
    const [selectedPreset, setSelectedPreset] = useState(Presets.TODAY);
    const handleSelect = (selectedRange) => {
        setStartMonth(selectedRange.from || new Date());
        setEndMonth(selectedRange.to || new Date());
        setStartYear(selectedRange.from?.getFullYear() || new Date().getFullYear());
        setEndYear(selectedRange.to?.getFullYear() || new Date().getFullYear());
        setRange(selectedRange);
        onSelect?.(selectedRange);
    };
    const handleStartMonthChange = (newMonth) => {
        const newMonthIndex = months.indexOf(newMonth);
        const newDate = new Date(startYear, newMonthIndex, 1);
        setStartMonth(newDate);
    };
    const handleEndMonthChange = (newMonth) => {
        const newMonthIndex = months.indexOf(newMonth);
        const newDate = new Date(endYear, newMonthIndex, 1);
        setEndMonth(newDate);
    };
    const handleStartYearChange = (newYear) => {
        const newYearNumber = Number(newYear);
        setStartYear(newYearNumber);
        setStartMonth(new Date(newYearNumber, startMonth.getMonth(), 1));
    };
    const handleEndYearChange = (newYear) => {
        const newYearNumber = Number(newYear);
        setEndYear(newYearNumber);
        setEndMonth(new Date(newYearNumber, endMonth.getMonth(), 1));
    };
    const handleSelectPreset = (preset) => {
        const { key, start, end } = preset;
        const newRange = { from: start, to: end }; // Create new range object
        setSelectedPreset(key);
        setStartMonth(start);
        setEndMonth(end);
        setStartYear(start.getFullYear());
        setEndYear(end.getFullYear());
        setRange(newRange);
        onSelect?.(newRange);
    };
    const buttonLabel = range?.from && range?.to ? `${format(range.from, "dd/MM/yyyy")} → ${format(range.to, "dd/MM/yyyy")}` : placeholder;
    return (_jsxs(Popover, { children: [_jsx(PopoverTrigger, { asChild: true, children: _jsx(Button, { "data-testid": "datepicker", variant: "outlined", color: "default", startIcon: _jsx(Icon, { name: "calendar-days" }), endIcon: _jsx(Icon, { name: "chevron-down" }), size: size, disabled: disabledTrigger, className: className, children: buttonLabel }) }), _jsxs(PopoverContent, { align: "start", showArrow: false, className: cn("flex gap-4", classNameContent), portal: portal, children: [!availablePresets ||
                        (availablePresets.length > 0 && (_jsxs(_Fragment, { children: [_jsx(DatePresets, { selectedPreset: selectedPreset, availablePresets: availablePresets, onSelectPreset: handleSelectPreset }), _jsx(Divider, { orientation: "vertical", className: "h-auto" })] }))), _jsxs("div", { className: "space-y-4", children: [_jsx(RangeDatePickerHeader, { startMonth: startMonth, endMonth: endMonth, startYear: startYear, endYear: endYear, onStartMonthChange: handleStartMonthChange, onEndMonthChange: handleEndMonthChange, onStartYearChange: handleStartYearChange, onEndYearChange: handleEndYearChange, yearsRange: yearsRange }), _jsx(Calendar, { ...calendarProps, mode: "range", selected: range, onSelect: handleSelect, month: startMonth, numberOfMonths: 2, onMonthChange: setStartMonth, required: true, disabled: disabled })] })] })] }));
};
export default RangeDatePicker;
